export default __webpack_public_path__ + "static/media/medicine-capsules-global-health-with-geometric-pattern-digital-remix.8832ace4.jpg";